import { BotaoComprarTimer } from "@/components/vitrine/components/BotaoComprarTimer"
import { FavoriteButton } from "@/components/vitrine/components/Favorite-button"
import { MidiaProdutoVitrine } from "@/components/vitrine/components/MidiaProdutoVitrine"
import { TagsImagem } from "@/components/vitrine/components/TagsImagem"
import { Device } from "@/components/vitrine/data/device"
import { TipoPagamento } from "@/components/vitrine/data/tipoPagamento"
import type { Produto } from "@/components/vitrine/types/produto.props"
import { priceFormatter } from "@/utils/formatter"
import { getLinkProduto } from "@/utils/getLinkProduto"
import { getResourceFromS3 } from "@/utils/getResourceFromS3"

interface ProdutoCardProps {
    hostImagem: string
    produto: Produto
    index: number
    precoPrincipal: number
    condicaoParcelamento: number
    validaTempoVitrine: boolean
    zordHintLoading: string
    device: number
    vitrineButtonAddToCart: string
    exibeValoresSomenteLogado: boolean
    width: number
    height: number
    hoverImagensVitrine: boolean
    hoverImagensVitrineMobile: boolean
    utilizaFavoritosVitrine: boolean
}

export function ProdutoCard({
    hostImagem,
    produto,
    index,
    precoPrincipal,
    condicaoParcelamento,
    validaTempoVitrine,
    zordHintLoading,
    device,
    vitrineButtonAddToCart,
    exibeValoresSomenteLogado,
    width,
    height,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine
}: ProdutoCardProps) {
    const valor_boleto = produto.valor_boleto
    const valor_pix = produto.valor_pix
    const valor_parcelado = produto.valor_cartao
    let valorParcelado = 0
    let qtdParcelas = 1
    let valorParcelas = 0

    if (valor_parcelado && valor_parcelado.length > 0) {
        if (condicaoParcelamento == 1) {
            valorParcelado = produto.valor
            valorParcelas = valorParcelado
        } else if (condicaoParcelamento == 2 && valor_parcelado[5]) {
            valorParcelado = valor_parcelado[5]['valor']
            qtdParcelas = valor_parcelado[5]['parcelas']
            valorParcelas =  valor_parcelado[5]['valorParcela']
        } else {
            valorParcelado = valor_parcelado[1]
            qtdParcelas = valor_parcelado[0]
            valorParcelas = valor_parcelado[2]
        }
    }

    return (
        exibeValoresSomenteLogado ? (
            <div
                className={`product-card flex center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' column' : ''}`}
                data-id={produto.codigo}
                data-name={produto.titulo ? produto.nome : produto.titulo}
                data-variant={produto.derivacao_nome}
                data-brand={produto.marca}
                data-position={index + 1}
            >
                <div className="product-image flex center justify-center">
                    <a
                        href={getLinkProduto(produto)}
                        className={`${produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                        <figure className="flex">
                            <MidiaProdutoVitrine
                                hostImagem={hostImagem}
                                produto={produto}
                                width={width}
                                height={height}
                                hoverImagensVitrine={hoverImagensVitrine}
                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                            />
                                                        
                            <TagsImagem produto={produto} hasTagEmbaixoProduto={false} utilizaFavoritosVitrine={utilizaFavoritosVitrine} />

                            {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                        </figure>
                    </a>
                </div>

                <div className="product-info">
                    <div className="container-top-product-info flex center{{ app.getDevice().isTablet() or app.getDevice().isMobile() ? ' justify-center' }}">
                        {produto.marca && (
                            <div className="produto-marca">
                                <span>{produto.marca}</span>
                            </div>
                        )}
                    </div>
                    
                    <a href={getLinkProduto(produto)} className={`${produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                        <div className="product-name">
                            {produto.titulo ? produto.titulo : produto.nome}
                        </div>
                    </a>

                    <TagsImagem produto={produto} hasTagEmbaixoProduto={true} utilizaFavoritosVitrine={utilizaFavoritosVitrine} />

                    <div className="valores-logados-vitrine">
                        <span>
                            Faça login para ver os preços
                        </span>

                        <a href={`/login?redir=${encodeURIComponent(globalThis.window.location.href)}`} className="btn-comprar-vitrine flex center justify-center">
                            Fazer login
                        </a>
                    </div>
                </div>
            </div>
        ) : (
            <a href={getLinkProduto(produto)} className={`${produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}`}>
                <div
                    className={`product-card flex center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' column' : ''}`}
                    data-id={produto.codigo}
                    data-name={produto.titulo ? produto.nome : produto.titulo}
                    data-variant={produto.derivacao_nome}
                    data-brand={produto.marca}
                    data-position={index + 1}
                >
                    <div className="product-image flex center justify-center">
                        <figure className="flex">
                             <MidiaProdutoVitrine
                                hostImagem={hostImagem}
                                produto={produto}
                                width={width}
                                height={height}
                                hoverImagensVitrine={hoverImagensVitrine}
                                hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                            />
                                                        
                            <TagsImagem produto={produto} hasTagEmbaixoProduto={false} utilizaFavoritosVitrine={utilizaFavoritosVitrine} />
                            
                            {utilizaFavoritosVitrine && <FavoriteButton produto={produto} />}
                        </figure>
                    </div>

                    <div className="product-info">
                        <div className={`container-top-product-info flex center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' justify-center' : ''}`}>
                            {produto.marca && (
                                <div className="produto-marca">
                                    <span>{produto.marca}</span>
                                </div>
                            )}
                        </div>

                        <div className="product-name">
                            {produto.titulo ? produto.titulo : produto.nome}
                        </div>

                        <TagsImagem produto={produto} hasTagEmbaixoProduto={true} utilizaFavoritosVitrine={utilizaFavoritosVitrine} />

                        <div className={`price-product flex${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' column' : ''}`}>
                            {((precoPrincipal == TipoPagamento.CARTAO) && (valor_parcelado[0] && valor_parcelado.length > 0)) ? (
                                <>
                                    <div className={`primary-price flex wrap center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' justify-center' : ''}`}>
                                        <div className="icon-payment flex center">
                                            <img
                                                className="lazyload lazyload-svg"
                                                src={zordHintLoading}
                                                data-src={getResourceFromS3('assets/global/vitrines-landing-page', 'icon-card.svg')}
                                                width="24"
                                                height="24"
                                                alt="Pagamento no Cartão"
                                                title="Pagamento no Cartão"
                                            />
                                        </div>
                                        <div className="price-big">{priceFormatter.format(valorParcelado)}</div>
                                        <div className="condicacao-pagto">no Cartão</div>
                                    </div>

                                    {(valor_parcelado && valor_parcelado.length > 0) && (
                                        <div className="secondary-price flex wrap center justify-center">
                                            <span className="parcelas">{qtdParcelas}x de</span>
                                            <strong>{priceFormatter.format(valorParcelas)}</strong>
                                        </div>
                                    )}
                                </>
                            ) : (precoPrincipal == TipoPagamento.BOLETO) ? (
                                <>
                                    {(valor_boleto > 0) && (
                                        <div className={`primary-price flex wrap center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' justify-center' : ''}`}>
                                            <div className="icon-payment flex center">
                                                <img
                                                    className="lazyload lazyload-svg"
                                                    src={zordHintLoading}
                                                    data-src={getResourceFromS3('assets/global/vitrines-landing-page', 'icon-boleto.svg')}
                                                    width="24"
                                                    height="24"
                                                    alt="Pagamento no Boleto"
                                                    title="Pagamento no Boleto"
                                                />
                                            </div>
                                            <div className="price-big">{priceFormatter.format(valor_boleto)}</div>
                                            <div className="condicacao-pagto">no Boleto</div>
                                        </div>
                                    )}

                                    {valor_parcelado && valor_parcelado.length > 0 && (
                                        <div className="secondary-price flex wrap center justify-center">
                                            <div className="icon-payment flex center">
                                                <img
                                                    className="lazyload lazyload-svg"
                                                    src={zordHintLoading}
                                                    data-src={getResourceFromS3('assets/global/vitrines-landing-page', 'icon-card.svg')}
                                                    width="24"
                                                    height="24"
                                                    alt="Pagamento no Cartão"
                                                    title="Pagamento no Cartão"
                                                />
                                            </div>
                                            <span className="parcelas">ou {qtdParcelas}x de</span>
                                            <strong>{priceFormatter.format(valorParcelas)}</strong>
                                        </div>
                                    )}
                                </>
                            ) : (precoPrincipal == TipoPagamento.PIX) && (
                                <>
                                    {(valor_pix > 0) && (
                                        <div className={`primary-price flex wrap center${[Device.MOBILE, Device.APP, Device.TABLET].includes(device) ? ' justify-center' : ''}`}>
                                            <div className="icon-payment icon-payment-pix flex center">
                                                <img
                                                    className="lazyload lazyload-svg"
                                                    src={zordHintLoading}
                                                    data-src={getResourceFromS3('assets/global/vitrines-landing-page', 'icon-pix.svg')}
                                                    width="24"
                                                    height="24"
                                                    alt="Pagamento no Pix"
                                                    title="Pagamento no Pix"
                                                />
                                            </div>
                                            <div className="price-big">{priceFormatter.format(valor_pix)}</div>
                                            <div className="condicacao-pagto">no Pix</div>
                                        </div>
                                    )}

                                    {(valor_parcelado && valor_parcelado.length > 0) && (
                                        <div className="secondary-price flex wrap center justify-center">
                                            <div className="icon-payment icon-payment-boleto flex center">
                                                <img
                                                    className="lazyload lazyload-svg"
                                                    src={zordHintLoading}
                                                    data-src={getResourceFromS3('assets/global/vitrines-landing-page', 'icon-card.svg')}
                                                    width="24"
                                                    height="24"
                                                    alt="Pagamento no cartão"
                                                    title="Pagamento no cartão"
                                                />
                                            </div>
                                            <span className="parcelas">ou {qtdParcelas}x de</span>
                                            <strong>{priceFormatter.format(valorParcelas)}</strong>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                        <BotaoComprarTimer
                            produto={produto}
                            validaTempoVitrine={validaTempoVitrine}
                            zordHintLoading={zordHintLoading}
                            vitrineButtonAddToCart={vitrineButtonAddToCart}
                            device={device}
                        />
                    </div>
                </div>
            </a>
        )
    )
}